<div class="flex font16-w500">
    <div class="flex-v-center mr10 cursor-pointer text-primaryBlue" (click)="markAsRead(true)">
        <svg-icon  [iconName]="'new/read.svg'" class="mr-2" [size]="20"></svg-icon>
        <span>{{"MARK_AS_ALL_READ" | translate}}</span>
      </div>
      <div class="flex-v-center cursor-pointer text-primaryBlue ml-6" (click)="goPage('notification/setting')">
        <svg-icon  [iconName]="'new/settings.svg'" class="mr-2" [size]="24"></svg-icon>
        <span>{{"SETTING" | translate}}</span>
      </div>
</div>
<!-- <cdk-virtual-scroll-viewport itemSize="50" class="viewport"> -->
<ul class="msgList mb20" *ngIf="notificationList.length>0">
    <li clss="msg mt20" *ngFor="let notification of notificationList" >
        <div class="flex-between items-center">
            <div class="flex-1 font-bold truncate" [attr.title]="notification?.contentModel?.title"><i *ngIf="notification?.isRead===0" class="not-read mr6"></i>{{notification?.contentModel?.title}}</div>
            <div class="date">{{notification?.sendTime}}</div>
        </div>
      <p class="overflow-ellipsis  color-grey7C mb10">{{notification?.contentModel?.content}}</p>
      <div class="mx:flex operation">
        <div class="primary-small-btn text-center order-2 sm:mb-[14px] mx:mr-[14px] flex-center" *ngIf="notification?.contentModel?.url" (click)="checkUrl(notification?.contentModel?.url)">
          <svg-icon [iconName]="'new/arrow-right.svg'" [size]="24" class="mr6"></svg-icon>
          <span>{{"CHECK" | translate}}</span>
        </div>
        <div class="default-small-btn flex-center text-center order-1 mx:mr-[14px]" *ngIf="notification?.isRead===0"  (click)="markAsRead(false,notification.id)">
            <svg-icon [iconName]="'new/read.svg'" [size]="20" class="mr6"></svg-icon>
            <span>{{"MARK_AS_READ" | translate}}</span>
          </div>

      </div>
    </li>
  </ul>
  <div *ngIf="notificationList.length==0" class="flex-center no-message-wrap">
      <div>
        <svg-icon [iconName]="'no-msg.svg'" [size]="72"></svg-icon>
        <div class="no-message">{{"NO_MESSAGES" | translate}}</div>
      </div>
  </div>
<!-- </cdk-virtual-scroll-viewport> -->
